import { ContributionPoint } from '@img-arena/consoles-api-streaming'
import { Column, COLUMN_CELL_TYPE, Filter } from '@/components/table/base'
import { FilterType } from '@/components/table/base/FilterableTable/FilterableTable.types'

import {
  FOLLOW_PROPERTY_TOURNAMENT,
  FormattedContributionPointData
} from './ContributionPointsView'

export const CONTRIBUTION_POINTS_COLUMNS: Column<FormattedContributionPointData>[] = [
  {
    id: 'property.sport.name',
    label: 'Sport',
    type: COLUMN_CELL_TYPE.TEXT
  },
  {
    id: 'property.name',
    label: 'Property',
    type: COLUMN_CELL_TYPE.TEXT
  },
  {
    id: 'tournament.name',
    label: 'Tournament',
    type: COLUMN_CELL_TYPE.TEXT
  },
  {
    id: '$tournament',
    label: 'No of Contribution Points',
    type: COLUMN_CELL_TYPE.NUMBER,
    transform: (value: FormattedContributionPointData) => {
      const { url } = value
      return url.length
    }
  }
]

export const CONTRIBUTION_POINTS_SUBTABLE_COLUMNS: Column<ContributionPoint>[] = [
  {
    id: 'name',
    label: 'Contribution Point URL',
    type: COLUMN_CELL_TYPE.TEXT
  },
  {
    id: '$events',
    label: 'No of Events Assigned',
    type: COLUMN_CELL_TYPE.NUMBER,
    transform: (value: ContributionPoint) => {
      const { events } = value
      return events.length
    }
  },
  {
    id: 'provisionedEvent',
    label: 'Event Currently Using',
    type: COLUMN_CELL_TYPE.TEXT
  },
  {
    id: 'createdDate',
    label: 'Date Created',
    type: COLUMN_CELL_TYPE.DATE
  }
]

const getOptions = (data: FormattedContributionPointData[]) => {
  const options = data.reduce(
    (acc: Record<'sportOptions' | 'propertyOptions' | 'tournamentOptions', FilterType[]>, item) => {
      const { property, tournament } = item
      const sport = property.sport

      if (!acc.sportOptions[sport.id]) {
        acc.sportOptions[sport.id] = {
          value: sport.id.toString(),
          label: property.sport.name
        }
      }

      if (!acc.propertyOptions[property.id]) {
        acc.propertyOptions[property.id] = {
          value: property.id.toString(),
          label: property.name
        }
      }

      if (
        tournament &&
        (tournament.id !== undefined || tournament.id !== null) &&
        !acc.tournamentOptions[tournament.id]
      ) {
        acc.tournamentOptions[tournament.id] = {
          value: tournament.id.toString(),
          label: tournament.name
        }
      }

      return acc
    },
    {
      sportOptions: [],
      propertyOptions: [],
      tournamentOptions: []
    }
  )

  options.tournamentOptions.push({
    value: FOLLOW_PROPERTY_TOURNAMENT.id.toString(),
    label: FOLLOW_PROPERTY_TOURNAMENT.name
  })

  return options
}

export const getContributionPointsFilters = (
  data: FormattedContributionPointData[]
): Filter<FormattedContributionPointData>[] => {
  const { sportOptions, propertyOptions, tournamentOptions } = getOptions(data)

  return [
    {
      paramName: 'url',
      type: 'freeTextSearch',
      filterOptions: (item, value) => {
        const { url } = item
        return url.some((contributionPoint) => {
          return contributionPoint.name.toLowerCase().includes(value.toLowerCase())
        })
      }
    },
    {
      paramName: 'property.sport.name',
      type: 'select',
      label: 'Sport',
      options: sportOptions,
      filterOptions: (item, [filter]) => {
        const { property } = item
        return property.sport.id === Number(filter.value)
      }
    },
    {
      paramName: 'property.name',
      type: 'select',
      label: 'Property',
      options: propertyOptions,
      filterOptions: (item, [filter]) => {
        const { property } = item
        return property.id === Number(filter.value)
      }
    },
    {
      paramName: 'tournament.name',
      type: 'select',
      label: 'Tournament',
      options: tournamentOptions,
      filterOptions: (item, [filter]) => {
        const { tournament } = item
        if (!tournament) return false
        return tournament.id === Number(filter.value)
      }
    }
  ]
}
